<template>
    <ShowIfHasAccess
        :feature-id="AccessFeature.collections"
        :resource="AccessResource.collections"
        :action="AccessAction.write"
        ignore-conditions
    >
        <div>
            <QitButton
                padding="sm"
                icon="fak fa-regular fa-regular-bookmark-circle-plus default-grey-icon-color"
                :size="size"
                :color="color"
                :class="classes"
                :data-qs="dataQs"
                :flat="isFlat"
                @click.stop.prevent="$emit('click')"
            >
                <q-tooltip>{{ $t("shared.Add to Collection") }}</q-tooltip>
            </QitButton>
        </div>
    </ShowIfHasAccess>
</template>

<script setup lang="ts">
import QitButton from "@/shared/components/buttons/qit-button.vue";
import { AccessAction, AccessFeature, AccessResource } from "@/shared/access-control/access-control.ts";
import ShowIfHasAccess from "@/shared/access-control/components/show-if-has-access.vue";
import { computed } from "vue";
import { useScreenSize } from "@/shared/screen/composables/screen-size.ts";

const props = defineProps<{ size?: string; color?: string; class?: string; dataQs?: string }>();
defineEmits<{ click: [] }>();

const { isXSmall } = useScreenSize();

const size = computed(() => {
    return props.size ?? "12px";
});

const isFlat = computed(() => {
    return props.color !== "secondary";
});

const color = computed(() => {
    if (props.color) return props.color;

    return "none";
});

const classes = computed(() => [props.class, { border: isXSmall.value && isFlat.value }]);
</script>
